export function useFilterSidebarOpenState() {
  const openedState = useState<Record<string, boolean>>(
    "__opened-filters__",
    () => ({}),
  );

  function reset(): void {
    openedState.value = {};
  }

  return {
    openedState,
    reset,
  };
}
